import OrganizationContainerLazyLoader from 'src/components/Organization/pages/OrganizationContainerLazyLoader';

export default OrganizationContainerLazyLoader;
